import React,{useContext, useEffect, useState} from "react";

import Footer from "./footer";

import Counter from "./countertext";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import HomeCounters from "./Homecounters";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";



function Trademarkregistration() {

   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setNewData((prevData) => ({
          ...prevData,
          user_name: parsedUser.name || "",
          user_email_address: parsedUser.email || "",
          user_phone_number: parsedUser.mobile || "",
          user_city: parsedUser.city || "",
        }));
      }
    }, []);


   const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };


   const[newData,setNewData]=useState({user_name:'',user_email_address:'',user_phone_number:'',user_city:''})
   const [errors, setErrors] = useState({});
      const { services, loading, error } = useContext(ServicesContext);  
      if (loading) {
         return <div>Loading...</div>;  // Show loading state while fetching data
     }
   
     if (error) {
          return <div>{error}</div> // Show error state if there was an issue fetching data
     }
      const service = services.find(s => s.service_id === 12);

   const validateForm = () => {
      const newErrors = {};

      // Name validation
      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      }   else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
       }

      // Email validation
      if (!newData.user_email_address.trim()) {
         newErrors.user_email_address = 'Email address is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email_address)) {
         newErrors.user_email_address = 'Enter a valid email address.';
      }

      // Phone number validation
      // if (newData.user_phone_number && !/^\d{10}$/.test(newData.user_phone_number)) {
      //    newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
      // }

      if (!newData.user_phone_number.trim()) {
         newErrors.user_phone_number = 'number is required.';
       } else if (!/^\d{10}$/.test(newData.user_phone_number)) {
         newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
       }


      // City validation
      if (!newData.user_city) {
         newErrors.user_city = 'City/District is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // Returns true if no errors
   };


   const formPutPartenshipdeed = async (e) => {
               e.preventDefault();
    // ✅ Check if user is logged in
   //  if (!token) {
   //     alert("Please log in to continue.");
   //       localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
   //    navigate('/login'); // 👈 Use this if you're using React Router
   //    return;
   // }

               if (!validateForm()) return;
             
               localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });
                
             };

   
    return (
      <div>
             
      
        <div className="hero-area10 header-background">
        <div className="container">
        <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2  ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt=""/>
                        </div>
                        <h1 className="sk-text-color">Trademark Registration</h1>
                        <p className="pdrl-text">Get Trademark Registration for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Govt. Fees As per actual Extra)</span></p>
                        <p className="pd-text">Establish your brand with a ™ symbol on your logo, slogan, or company name. Protect your intellectual property today.</p>
                        <div className="banner">
                           <img src="assets/icons/banner.svg" alt="" srcset="" />
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt=""/>
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>Book Service Now </h3>
                           <p className="pdrl-text">at Rs.{service?.price}/- Only <span><br/>(Govt. Fees As per actual Extra)</span></p>
                        </div>
                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                 <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Email Address<span className="red">*</span></label>{errors.user_email_address && <p className="error-text">{errors.user_email_address}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email_address} onChange={(e) => setNewData({ ...newData, user_email_address: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Contact Number<span className="red">*</span></label> {errors.user_phone_number && <p className="error-text">{errors.user_phone_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_phone_number} onChange={(e) => setNewData({ ...newData, user_phone_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                    <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_city"
                                          errors={errors}
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>
  
           <div className="space60 bg-white"></div>
  
           <div className="home4-counters bg-white">
              <div className="container">
                
              <div className="row">
                  <div className="col-md-12">

                 
                     <HomeCounters />
                  </div>
               </div>

                
                <div className="space40"></div>
                <div className="row">
                  <div className="col-lg-12">
                     <p className="pd-text"> Securing a trademark safeguards your intellectual property while establishing your brand as credible and authoritative. In today's digital landscape, the ™ symbol next to your brand name, tagline, or logo enhances your reputation and market value. At Dm2Legal, our experts handle the entire process, ensuring you retain full ownership and control over your assets. Trust Dm2Legal for expert guidance and comprehensive protection of your intellectual property.</p>

                     <p className="pd-text">Trademark registration in India is essential for individuals or companies who want to protect their logo from unauthorized use by third parties. It grants the legal right to take action against any infringement of the trademark. Additionally, trademark registration provides the owner with exclusive rights to use the trademark for their products or services. Various types of trademarks can be registered, including product marks, service marks, collective marks, certification marks, shape marks, sound marks, and pattern marks.</p>
                  </div>
               </div>

                 <div className="space20"></div>
                 
              </div>
           </div>
  
  
           <div className="service-binifits9 sp0" id="service2" >
            <div className="space40"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <h2 className="text-center">Benefits of Online Trademark Registration with Dm2Legal</h2>
                        <div className="service-binifits-boxs">
                           <div className="row">
                              <div className="col-md-4">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>   
                                          Expert Legal Guidance</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>   
                                          Manage your documents digitally.</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>   
                                          The best customer support systems.</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>   
                                          Secure systems to maintain confidentiality.</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>   
                                          Accelerate the Trademark Registration Process</p>
                                    </div>
                                 </div>
                              </div>
                              <div className="col-md-4">
                                 <div className="single-boxs">
                                    &nbsp;&nbsp;
                                    <div className="icon">
                                       <p> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>   
                                          Monitor your trademark once it has been registered.</p>
                                    </div>
                                 </div>
                              </div>
                             
                           </div>
                        </div>
                     </div>
                  </div>
                  <div className="space30"></div>
               </div>
            </div>
         </div>
        
           <div className="bg-white">
           <div className="container">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Understanding the Trademark Registration Process in India </h2>
                        <div className="space20"></div>
                        <p className="pd-text"> In India, trademarks are protected under the Trademark Act of 1999 and can be registered across 45 classes of goods and services. Upon application, the Registrar reviews it, and applicants typically receive an update on their registration status within 30 days.</p>
                        <div className="space20"></div>
                        <p className="pd-text">The trademark registration process involves choosing a unique brand name, submitting an application with supporting documents like a Power of Attorney (POA), and undergoing examination and opposition hearings. However, trademarks that offend religious sentiments or specific groups in India cannot be registered.</p>
                        <div className="space20"></div>
                        <p className="pd-text">Trademarks set your business apart, establish brand recognition, and protect against duplication. They enhance your market presence and expand your business reach, ensuring long-term growth and credibility.</p>
                        <div className="space20"></div>
                        <p className="pd-text">Anyone can register a trademark for their unique words or symbols, even without engaging in business activities. Trademark registration is open to individuals, ensuring exclusive rights and brand protection.</p>
                     </div>
                  </div>
                  <div className="col-lg-12">
                     <p> &nbsp;</p>
                  <p className="pd-text">There are different types of trademarks provided by the Trademark Act in India:</p>
                  </div>
                  <div className="col-lg-4">
                     <div className="hadding7">
                        <div className="space20"></div>
                  
                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Product Mark</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Service Mark</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Collective Mark</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Certification Mark</li>
                           
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <div className="hadding7">
                        <div className="space20"></div>
                       
                        <div className="contact6-list">
                           <ul>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Shape Mark</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Pattern Mark</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Sound Mark and more.</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-3">
                                  <img src="assets/img/images/Understanding-the-Trademark-Registration-Process-in-India.jpg" alt=""/>
                  </div>
               </div>

               <div className="row">
               <div className="col-lg-12">
                  <div className="hadding7">
                     <div className="space40"></div>
                     <h2  className="text-center">Importance of Professional Trademark Registration  </h2>
                     <div className="space20"></div>
                  </div>
               </div>
               <div className="col-lg-4">
                  <div className="space30"></div>
                  <img src="assets/img/images/Importance-of-Professional-Trademark-Registration.png" alt="" />
               </div>
               <div className="col-lg-8">
                  <div className="hadding7">
                     <div className="space20"></div>
                     <p className="pd-text">Professional trademark registration is essential for distinguishing your products and their origin. It conveys your brand’s identity and story, and once registered, it strengthens your business’s transformation into a recognizable brand.</p>
                     <div className="space20"></div>
                     <p className="pd-text">Trademark registration safeguards your brand’s value, ensures product quality, and builds customer trust. It grants exclusive ownership rights and legal protection, helping your business establish a strong and unique identity.</p>
                     <div className="space20"></div>
                     <p className="pd-text">Registering your trademark enhances brand recognition, communicates your business’s purpose, and sets you apart from competitors. In today’s digital era, it also opens doors for global expansion and strengthens your industry presence.</p>
                  </div>
               </div>
            </div>

            <div className="row">
               <div className="col-lg-12">
                  <div className="hadding7">
                     <div className="space40"></div>
                     <h2  className="text-center">Trademark Registration: Step-by-Step Guide </h2>
                     <div className="space40"></div>
                  </div>
               </div>
               <div className="col-lg-8">
                  <div className="contact6-list doc-list">
                     <ul>
                        <li className="font-f-7 ">
                          <div className="step-font-size"> <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Step 1: Selection of Trademark</div>
                           <div className="space10"></div>
                           <p className="pd-text">The first step in trademark registration is selecting your trademark and checking its availability on the Trademark Registration website.</p>
                        </li>
                        <hr/>
                        <li className="font-f-7">
                        <div className="step-font-size">  <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span> Step 2: Trademark Filing</div>
                           <div className="space10"></div>
                           <p className="pd-text">The next step in trademark registration is completing the TM-A form, which must be submitted to the Trademark Registry.</p>
                        </li>
                        <hr/>
                        <li className="font-f-7">
                        <div className="step-font-size">   <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 3: Trademark Examination</div>
                           <div className="space10"></div>
                           <p className="pd-text">The trademark office reviews your application to identify any conflicts with existing trademarks or other legal obstacles.</p>
                        </li>
                        <hr/>
                        <li className="font-f-7">
                        <div className="step-font-size">  <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 4: Trademark Publication</div>
                           <div className="space10"></div>
                           <p className="pd-text">Once there are no objections, your trademark application will be published in the Trademark Journal for three to four months. This stage is referred to as "Accepted and Advertised."</p>
                        </li>
                        <hr/>
                        <li className="font-f-7">
                        <div className="step-font-size">  <span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Step 5: Trademark Registration</div>
                           <div className="space10"></div>
                           <p className="pd-text">If your application receives no opposition, your trademark will be successfully registered. You will then receive a trademark certificate as proof of your exclusive rights.</p>
                        </li>
                     </ul>
                  </div>
               </div>
               <div className="col-lg-4">
                  <div className="space30"></div>
                  <img src="assets/img/images/Trademark-Registration-Step-by-Step-Guide-.png" alt="" />
               </div>
            </div>

            <div className="row">
               <div className="col-lg-12">
                  <div className="hadding7">
                     <div className="space40"></div>
                     <h2  className="text-center">Documents Needed for Trademark Registration</h2>
                     <p className="text-center pd-text">Documents required for Trademark registration</p>
                     <div className="space20"></div>
                  </div>
               </div>
               <div className="col-lg-5">
                  <img src="assets/img/images/Documents-Needed-for-Trademark-Registration.png" alt=""/>
               </div>
               <div className="col-lg-7">
                  <div className="contact6-list doc-list">
                     <ul>
                        <li className="font-f-7 "><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Aadhaar card of applicant</li>
                        <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Aadhaar Card / Driving Liscence / Voter ID (any one) of Applicant</li>
                        <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Certificate of incorporation (other than Individual applicant)</li>
                        <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Brand Name (To be Trademarked)</li>
                        <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Brand Logo (To be Trademarked)</li>
                        <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Start-up Recognition (optional)</li>
                        <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>MSME Registration (optional)</li>
                        <li className="font-f-7"><span><img className="arow" src="assets/image/doc-01.svg" alt="" /></span>Authorization letter (POA)</li>
                     </ul>
                  </div>
               </div>
            </div>
            </div>
                   </div>

                   <div className="service-binifits9 sp0" id="service2">
            <div className="container work8">
               <div className="row">
                  <div className="col-lg-12 text-center">
                     <div className="hadding7">
                        <div className="space80"></div>
                        <h2 className="text-center">The Process of Trademark Registration Online  </h2>
                     </div>
                     <div className="partnership-deade-section">
                        <div className="space40"></div>
                       
                        <ul className="disc-list">
                           <li><h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our team will carefully review the documents you have submitted to ensure there are no mistakes.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our top trademark search experts are here to assess the uniqueness of the logo or wordmark you have submitted.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Experts will decide on a relevant className for your ™ according to the information given by you & proceed further for your trademark registration.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>Our experts will determine the appropriate className for your trademark based on the information you provide and proceed with the trademark registration process.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li><h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>
                              <span>We will provide you with the application number, which you can use to track the status of your trademark.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                        </ul>
            
                        <div className="space80"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

        <div className="bg-white">

         <div className="container ">
    

         <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">Trademark Registration: FAQs and Common Queries</h2>
                              <div className="space30"></div>
                          

                              <div id="general">


                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                        Q1: What is a Trademark?
                                        <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                        <p className="font-f-3 weight-500">
                                        A trademark is a unique symbol, word, logo, or phrase that identifies and differentiates a business’s products or services from others. It provides legal protection to prevent others from using similar marks.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                         Q2: Which authority is responsible for managing trademarks in India?
                                         <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       The Ministry of Commerce and Industry oversees trademarks in India, with the Controller General of Patents, Designs, and Trademarks handling registrations and protection under the Trade Marks Act, 1999.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                          Q3: How long is a trademark registration valid in India?
                                          <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                        <p className="font-f-3 weight-500">
                                        A trademark registration in India is valid for 10 years from the date of application. It can be renewed indefinitely in blocks of 10 years to maintain protection                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                        Q4: Is trademark registration valid internationally?
                                        <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                         <p className="font-f-3 weight-500">
                                         Trademark registration in India is valid only within India. To protect the trademark in other countries, the owner must apply for registration in each country or use international treaties like the Madrid Protocol.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                         Q5: Is it possible to register a trademark internationally?
                                         <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                      <p className="font-f-3 weight-500">
                                      Yes, you can register your trademark internationally through the Madrid Protocol, which allows you to apply for trademark protection in multiple countries with a single application.                                        </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6: Which types of trademarks are not eligible for registration?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                      <p className="font-f-3 weight-500">
                                      Trademarks that are descriptive, generic, deceptive, or similar to existing trademarks cannot be registered. Additionally, marks that contain scandalous or offensive content or violate public order are also ineligible.                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 7 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(7)}
                                    >
                                      Q7: Is trademark registration classified in any way?
                                      <span>
                                          {activeQuestion === 7 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 7 ? 'show' : ''
                                          }`}
                                    >
                                      <p className="font-f-3 weight-500">
                                      Yes, trademark registration is classified under 45 classes based on the type of goods or services the trademark represents. This system helps categorize trademarks to simplify the registration process.                                        </p>
                                    </div>
                                 </div>

                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 8 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(8)}
                                    >
                                       Q8: What actions can I take if someone else is using my trademark?
                                       <span>
                                          {activeQuestion === 8 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 8 ? 'show' : ''
                                          }`}
                                    >
                                        <p className="font-f-3 weight-500">
                                        If someone is using your registered trademark without permission, you can send them a cease and desist letter, file a trademark infringement lawsuit, or approach the Trademark Office for action. You can also seek legal remedies under the Trademark Act.                                        </p>
                                    </div>
                                 </div>

                            








                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
  
            </div>


           

         <Testimonials/>
  
           <div className="sp2 last-section bg-white">
            <div className="container">
            <div className="row">
                  <div className="col-lg-7 m-auto text-center">
                     <div className="hadding7">
                       
                        <h2>Why Choose Dm2Legal for Trademark Registration? </h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="#" >Convenient Registration</a></h4>
                           <p>Simply sign up with Dm2Legal for trademark registration services. Trademark registration grants the owner exclusive rights to use it for their products or services.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6" >
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Best Online Platform</a></h4>
                           <p>Dm2Legal is a leading platform for trademark registration. It is India’s largest platform, designed to make the trademark registration process smooth and efficient for its users.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Best Customer Support</a></h4>
                           <p>The Dm2Legal team is renowned for providing comprehensive support and assistance to our clients. We offer legal support even after your trademark registration and value your feedback.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>With over 10 years of experience in the legal industry, we are well-equipped to assist you. By choosing us, you will work with experienced legal experts, ensuring that any legal challenges during trademark registration are handled smoothly and efficiently.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >On-time Service</a></h4>
                           <p>Our team is committed to providing timely service without delays. We understand the value of your time and ensure that all legal formalities related to trademark registration are completed promptly.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Pocket-friendly Services</a></h4>
                           <p>We offer affordable and budget-friendly legal services for trademark registration that won't strain your finances. With every investment in our services, you’ll receive the best value in the market.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
  
  <div className="space40 bg-white"></div>
  
  <WhatsAppScrollButton/>
            <Footer />
       <CircularScrollProgress/>
      
      </div>
  
    );
  }
  export default Trademarkregistration;